﻿/* 
Object:         Documents
Description:    Logic and events for the module Documents
Used in:        Documents
*/

window.documents = function () {

    return {

        /**
         * initialize overview with all the events bound to the buttons.
         */
        initialize: function () {

            // Create new record ...
            $(".k-grid-add").click(function (e) {

                // Prevent default behaviour
                e.preventDefault();

                // Show mode 
                mode = "edit";

                // Load create form into the current module div
                navigation.navigateToSpecificUrl("Documents/NewItem");
            });
        },

        /**
         * delete a item (param is event data)
         * @param {any} e
         */
        deleteItem: function (e) {

            var event = e;
            var data = this;

            function callbackYes(event, data) {
                // Prevent default behaviour 
                event.preventDefault();

                var dataItem = data.dataItem($(event.currentTarget).closest("tr"));

                // Post Data
                $.ajax({
                    type: "GET",
                    url: appsettings.getUrl("Documents/Delete?documentId=" + dataItem.DocumentID),
                    success: function (responseData) {

                        // Refresh datasource grid 
                        $("#DocumentsGrid").data("kendoGrid").dataSource.read();

                    }
                });
            }

            function callingCallback() {
                callbackYes(event, data);
            }

            dialog.createDialog(callingCallback, function () { });

        },

        /**
         * update a item (param is event data)
         * @param {any} e
         */
        editItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Edit mode form
            viewmode.setViewMode(ModuleActionViewEnum.Edit);

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("Documents/EditItem?documentId=" + dataItem.DocumentID + "&breadcrumbLabel=" + dataItem.Label);
        },

        /**
         * show a item (param is event data)
         * @param {any} e
         */
        downloadItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));
            
            // Define the file URL
            var fileUrl = appsettings.getUrl("Documents/DownloadFile?documentId=" + dataItem.DocumentID);

            // Use jQuery to create an AJAX request to download the file
            $.ajax({
                url: fileUrl,
                type: 'GET',
                xhrFields: {
                    responseType: 'blob'
                },
                success: function (data, textStatus, request) {

                    var contentDisposition = request.getResponseHeader('Content-Disposition');
                    var fileName = contentDisposition.split(';')[1].trim().split('=')[1];

                    // Use the HTML5 "download" attribute to download the file
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(data);
                    link.download = fileName;
                    document.body.appendChild(link);
                    link.click();
                    $(link).remove();
                }
            });

            // Show mode form
            viewmode.setViewMode(ModuleActionViewEnum.Show);

        },

        visibilityItem: function (dataItem, nodeId) {
            return dataItem.NodeID === nodeId;
        }
    }

}();